<template>
  <v-app>
    <div id="no-rotate">
      <div class="wrapper">
        <h1>This is a portrait only app</h1>
        <h3>Please rotate your phone or disable auto-rotation</h3>
      </div>
    </div>
    <div v-if="loading" class="loading-bar"/>
    <v-main v-else :class="{ 'video-playing': activeVideo }" class="woo-main">
      <router-view />
    </v-main>
    <dev-menu/>
  </v-app>
</template>

<script>
import 'animate.css';
import Db from './helpers/Db';
import DevMenu from './components/DevMenu.vue';

export default {
  name: 'App',
  components: { DevMenu },
  data: () => ({
    loading: true
  }),
  computed: {
    activeVideo() {
      return this.$route.query.v || undefined;
    },
  },
  mounted() {
    Promise.all([
      Db.fetchToc().then(tutorials => {
        this.$store.commit('setTutorials', tutorials);
      }),
      Db.fetchHelp().then(help => {
        this.$store.commit('setHelp', help);
      })
    ]).then(() => {
      this.loading = false;
    });
  },
};
</script>
<style lang="scss">
@import "./styles/responsive.scss";

@font-face {
    font-family: 'AcherusGrotesque';
    src: url('./assets/fonts/Acherus-Grotesque-Bold.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'AcherusGrotesque';
    src: url('./assets/fonts/Acherus-Grotesque-Bold.otf') format('opentype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'AcherusGrotesque';
    src: url('./assets/fonts/Acherus-Grotesque-Black.otf') format('opentype');
    font-weight: 900;
    font-style: normal;
}

html,
body {
  overscroll-behavior-y: contain;
}
.v-application {
  font-family: "AcherusGrotesque" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.3 !important;

  text-align: center;
  letter-spacing: -0.02em;

  h1,
  h2,
  h3,
  h4 {
    font-style: normal;
    font-weight: 700;
  }

  h2 {
    font-size: 1.5rem;
  }

  .v-main {
    overflow: hidden;
  }

  a {
    text-decoration: none;
  }
  button.v-icon::before {
    padding: 1rem;
  }
}
#no-rotate {
  display: none;
}
.woo {
  &-button {
    font-weight: 800 !important;
    font-size: 1.125rem !important;
    width: 12.5rem;
    &.black {
      color: white !important;
      background-color: black !important;
    }
  }
  &-main {
    .v-main__wrap {
      position: static;
    }
  }
}
</style>
